"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headerCellClasses = exports.DriftTableHead = void 0;
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const TableRow_1 = require("../tableRow/TableRow");
const HeaderCell_1 = require("./HeaderCell");
Object.defineProperty(exports, "headerCellClasses", { enumerable: true, get: function () { return HeaderCell_1.headerCellClasses; } });
const noop = () => { };
const DriftTableHead = ({ columns, sort, onHeaderClick, isLoading }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(material_1.TableHead, null,
        react_1.default.createElement(TableRow_1.TableRow, null, columns.map((column) => {
            var _a, _b;
            return (react_1.default.createElement(HeaderCell_1.HeaderCell, { key: (_a = column.id) !== null && _a !== void 0 ? _a : column.label, label: column.label, align: (_b = column.align) !== null && _b !== void 0 ? _b : 'left', onClick: onHeaderClick ? () => onHeaderClick(column) : noop, sortDirection: (sort === null || sort === void 0 ? void 0 : sort.columnId) === column.id ? sort === null || sort === void 0 ? void 0 : sort.direction : undefined, isSortable: column.isSortable }));
        }))),
    isLoading && (react_1.default.createElement(material_1.LinearProgress, { sx: { backgroundColor: 'transparent', height: '2px', width: `calc(100% - 1px)`, position: 'absolute' } }))));
exports.DriftTableHead = DriftTableHead;
//# sourceMappingURL=DriftTableHead.js.map